var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGif = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.25 15.375a1.125 1.125 0 0 1-1.125-1.125v-9c0-.621.504-1.125 1.125-1.125h13.5c.621 0 1.125.504 1.125 1.125v9c0 .621-.504 1.125-1.125 1.125zM1 14.25a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 19 14.25v-9A2.25 2.25 0 0 0 16.75 3H3.25A2.25 2.25 0 0 0 1 5.25zm7.958-2.558q-.306.366-.865.57-.56.2-1.239.2-.714 0-1.254-.31a2.1 2.1 0 0 1-.83-.906q-.291-.593-.299-1.393v-.374q0-.825.276-1.424.28-.604.8-.922.525-.32 1.228-.32.978 0 1.53.468.55.464.653 1.356H7.855q-.075-.473-.336-.692-.257-.219-.71-.219-.578 0-.88.435-.301.435-.306 1.291v.352q0 .864.329 1.306t.963.442q.638 0 .91-.272v-.948H6.794v-.834h2.164zm2.126.695H9.951V6.888h1.133zm2.187-2.247h2.175v-.914H13.27v-1.42h2.447v-.918h-3.58v5.499h1.133z",
    clipRule: "evenodd"
  })));
};
export { SvgGif as ReactComponent };